<app-dialog-header title="Icônes"></app-dialog-header>

<mat-form-field subscriptSizing="dynamic" *ngIf="iconsDomino && (indexTab === 0 || indexTab === undefined)"
  class="search-field">
  <input matInput type="text" [formControl]="searchTermDomino" placeholder="Rechercher">
</mat-form-field>
<mat-form-field subscriptSizing="dynamic" *ngIf="iconsFontawesome && indexTab === 1" class="search-field"
  autocomplete="false">
  <input matInput type="text" [formControl]="searchTermFontawesome" placeholder="Rechercher">
</mat-form-field>

<div mat-dialog-content *ngIf="iconsDomino && iconsFontawesome; else loader">
  <mat-tab-group mat-stretch-tabs (selectedTabChange)="onTabChanged($event);" class="content-tab">

    <mat-tab label="Icones Domino">
      <ng-template matTabContent>
        <div *ngIf="iconsDomino; else loader" class="fx-direction-row fx-wrap thin-scrollbar">
          <mat-radio-group [(ngModel)]="selectedValueDomino" class="fx-direction-row fx-wrap fx-fill">
            <ng-container *ngFor="let option of iconsDomino; let i=index">
              <mat-radio-button class="container-radio fx-direction-row fx-center-center" value="{{ option }}"
                (change)="radioDominoChange($event)" style="flex: 1 1 8%; max-width: 8%;">
                <i style="font-size: 36px; margin: auto;" class="icodomino-{{option}}"
                  [ngClass]="{ 'accent': selectedValueDomino === option }"></i>
              </mat-radio-button>
            </ng-container>
            <div *ngIf="!iconsDomino.length" style="margin: 20vh 30px;">
              <h2>Pas d'icones correspondant à la recherche.</h2>
            </div>
          </mat-radio-group>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Icones Fontawesome">
      <ng-template matTabContent>
        <div *ngIf="iconsFontawesome; else loader" class="fx-direction-row fx-wrap thin-scrollbar">
          <mat-radio-group [(ngModel)]="selectedValueFontawesome" class="fx-direction-row fx-wrap fx-fill">
            <ng-container *ngFor="let option of iconsFontawesome; let i=index">
              <mat-radio-button class="container-radio fx-direction-row fx-center-center fx-flex-auto"
                *ngIf="i<=nbShowIcons" value="{{ option }}" (change)=radioFontawesomeChange($event)
                style="flex: 1 1 8%; max-width: 8%;">
                <i style="font-size: 32px; margin: auto;" class="{{option}}"
                  [ngClass]="{ 'accent': selectedValueFontawesome === option }"></i>
              </mat-radio-button>
            </ng-container>
            <div *ngIf="!iconsFontawesome.length" style="margin: 20vh 30px;">
              <h2>Pas d'icones correspondant à la recherche.</h2>
            </div>
          </mat-radio-group>
        </div>
        <button *ngIf="!loadMore" class="btnMore" color="primary" (click)="loadMoreIcons()" mat-stroked-button>
          <div class="fx-direction-row fx-center-center">
            <i class="fas fa-arrow-circle-down" style="font-size: 24px; margin-right: 15px;"></i>
            <span>Afficher plus d'icones...</span>
          </div>
        </button>
      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>

<div mat-dialog-actions class="fx-direction-row fx-between-center">

  <app-icon *ngIf="selectedValueFontawesome || selectedValueDomino"
    [icon]="selectedValueFontawesome ? selectedValueFontawesome : selectedValueDomino"
    [type]="selectedValueDomino ? 'do' : (!typeIcon && selectedValueFontawesome) ? 'faIconWithType' : typeIcon"
    [size]="36" ngClass="accent">
  </app-icon>

  <div>
    <button color="warn" *ngIf="selectedValueFontawesome || selectedValueDomino" mat-raised-button
      (click)='removeSelect()' mat-dialog-close>
      <mat-icon>not_interested</mat-icon> Retirer l'icone
    </button>
    <button mat-raised-button color="primary" mat-dialog-close (click)="validIcon()"
      *ngIf="selectedValueFontawesome || selectedValueDomino">Valider</button>
  </div>

</div>

<ng-template #loader>
  <div class="content-tab">
    <app-loader [message]="'Chargement des icones...'" class="margin"></app-loader>
  </div>
</ng-template>